import React, { ComponentPropsWithoutRef } from 'react';

export interface InputStateProps {
  error?: string, // eslint-disable-line react/no-unused-prop-types -- These are used, just not in this file.
  dirty?: boolean, // eslint-disable-line react/no-unused-prop-types -- These are used, just not in this file.
  touched?: boolean, // eslint-disable-line react/no-unused-prop-types -- These are used, just not in this file.
}

export interface InputProps extends ComponentPropsWithoutRef<'input'>, InputStateProps {
  className? : string,
}

export function Input({
  name,
  id,
  type,
  value,
  checked,
  className,
  autoComplete,
  'aria-required': ariaRequired,
  'aria-live': ariaLive,
  'aria-describedby': ariaDescribedBy,
  'aria-invalid': ariaInvalid,
  onChange,
  onBlur,
  onFocus,
  onKeyDown,
  placeholder,
  disabled,
}: InputProps) {
  return (
    <input
      id={id}
      name={name}
      value={value}
      checked={checked}
      type={type}
      className={className}
      autoComplete={autoComplete}
      aria-required={ariaRequired}
      aria-live={ariaLive}
      aria-invalid={ariaInvalid}
      aria-describedby={ariaDescribedBy}
      onBlur={onBlur}
      onChange={onChange}
      onFocus={onFocus}
      onKeyDown={onKeyDown}
      placeholder={placeholder}
      disabled={disabled}
    />
  );
}
